import { render, staticRenderFns } from "./CardWithReport.vue?vue&type=template&id=5a47b754&lang=pug&"
import script from "./CardWithReport.vue?vue&type=script&lang=ts&"
export * from "./CardWithReport.vue?vue&type=script&lang=ts&"
import style0 from "./CardWithReport.vue?vue&type=style&index=0&id=5a47b754&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports